import { useLocation } from "react-router";
import addLineBreaks from "../utils/addLineBreaks";
import { PRICE_MODE_MAX } from "../ducks/shoppingCartSlice";
import CommonHeader from "../containers/CommonHeader";
import FloatingProductOrderFooter from "../containers/FloatingProductOrderFooter";
import ProductPriceLabel from "../components/ProductPriceLabel";
import BestSellerBadge from "../components/BestSellerBadge";
import useGoTo from "../hooks/useGoTo";

/**
 * Tela do produto no totem, no tablet e no POS: foto grande, nome, descrição e
 * preço. As perguntas não ficam aqui; o botão do rodapé abre o wizard, uma
 * pergunta por tela (FloatingProductOrderFooterTotem).
 */
export default function ProductWithQuestionsTotem({
  onBack,
  product,
  pizzaPriceMode,
  isOrderVisible,
  orderUuid,
  orderUuidEdit,
}) {
  const goTo = useGoTo();
  // o state leva a marca do "Peça também" até a foto e de volta
  const { state } = useLocation();
  const goToImage = () => goTo(`/product/${product.id}/image`, state);

  return (
    <>
      <div className="totem-product-page">
        <CommonHeader text={product.name} onBack={onBack} />
        <article className="totem-product">
          {product.pictureUrl && (
            <div className="totem-product__media">
              <img
                src={product.pictureUrl}
                alt="Ilustração do produto"
                className="totem-product__img"
                onClick={goToImage}
              />
              {product.isBestSeller && <BestSellerBadge overlay />}
            </div>
          )}
          <div className="totem-product__info">
            <h2 className="totem-product__name">{product.name}</h2>
            {((product.isBestSeller && !product.pictureUrl) ||
              product.disabled) && (
              <div className="totem-product__badges">
                {product.isBestSeller && !product.pictureUrl && (
                  <BestSellerBadge />
                )}
                {product.disabled && (
                  <span className="tag tag--muted">Indisponível</span>
                )}
              </div>
            )}
            {product.details && (
              <p className="totem-product__details">
                {addLineBreaks(product.details)}
              </p>
            )}
            <p className="totem-product__price">
              <ProductPriceLabel product={product} />
            </p>
            {product.pizza && pizzaPriceMode === PRICE_MODE_MAX && (
              <p className="totem-product__note">
                A pizza com vários sabores é cobrada pelo preço do sabor mais
                caro.
              </p>
            )}
          </div>
        </article>
      </div>
      <FloatingProductOrderFooter
        isOrderVisible={isOrderVisible}
        orderUuid={orderUuid}
        orderUuidEdit={orderUuidEdit}
      />
    </>
  );
}
